import React from "react";
import { Link } from "react-router-dom";
import { Eye, Users, Utensils, Star, Award, CheckCircle2, FileClock, UserRound } from "lucide-react";

export function KitchenAnalytics({ stats, topRecipes, chefSlug }) {
  const cards = [
    { icon: Eye, label: "Recipe views", value: stats.recipe_views },
    { icon: UserRound, label: "Profile views", value: stats.profile_views },
    { icon: Users, label: "Followers", value: stats.followers },
    { icon: Utensils, label: "Live recipes", value: stats.recipes_published },
    { icon: FileClock, label: "In review / drafts", value: `${stats.pending} / ${stats.drafts}` },
    { icon: Star, label: "Avg recipe rating", value: stats.average_rating || "—" },
    { icon: Award, label: "Total ratings", value: stats.total_ratings },
    { icon: CheckCircle2, label: "“Made this” marks", value: stats.made_count },
  ];
  return (
    <div data-testid="kitchen-analytics">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3" data-testid="dashboard-stats">
        {cards.map((c) => (
          <div key={c.label} className="rounded-2xl bg-white border border-border shadow-soft p-5">
            <c.icon size={18} className="text-coral mb-2" />
            <p className="font-heading text-3xl font-black text-ink">{typeof c.value === "number" ? Number(c.value).toLocaleString() : c.value}</p>
            <p className="text-sm text-ink-soft font-semibold mt-0.5">{c.label}</p>
          </div>
        ))}
      </div>
      <h3 className="font-heading text-xl font-black text-ink mt-8 mb-3">Top recipes</h3>
      {topRecipes.length === 0 ? <p className="text-ink-soft text-sm">Your most-viewed live recipes will appear here.</p> : (
        <ol className="rounded-3xl bg-white border border-border shadow-soft divide-y divide-border overflow-hidden" data-testid="top-recipes">
          {topRecipes.map((r, i) => (
            <li key={r.id} className="flex items-center gap-3 p-4">
              <span className="grid place-items-center w-9 h-9 rounded-xl bg-ink text-white font-heading font-black text-sm">{String(i + 1).padStart(2, "0")}</span>
              <img src={r.thumbnail} alt="" className="w-12 h-12 rounded-xl object-cover border border-border" />
              <Link to={`/chefs/${chefSlug}/${r.slug}`} className="flex-1 min-w-0 font-heading font-black text-ink hover:text-coral truncate">{r.title}</Link>
              <span className="text-sm font-bold text-ink-soft inline-flex items-center gap-1 shrink-0"><Eye size={14} /> {Number(r.views).toLocaleString()}</span>
              <span className="text-sm font-bold text-amber-700 inline-flex items-center gap-1 shrink-0"><Star size={14} className="fill-gold text-gold" /> {r.rating_avg}</span>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
